import { isValidSixDecimalNumber, noZeroAfterSixDecimal } from 'utils/isValidSixDecimalNumber'

export const isValidEcosystemDecimalInput = (value) => {
  return isValidSixDecimalNumber(Number(value)) && noZeroAfterSixDecimal(value)
}

export const isAllowedAssessmentDateInput = (value, currentYear) => {
  return value <= currentYear && !value.includes('.') && !value.includes(' ') && (value > 0 || value === '')
}

export const isPersistableAssessmentDate = (value, currentYear) => {
  return value <= currentYear && value > 1900 && value.length === 4
}

